import { Injectable } from '@angular/core';

import { ToastMessagesServiceBase } from 'Angular/features/components/toast-messages/toast-messages-service-base';

/**
 * Toast messages rendered by the side menu's own outlet, so side-menu events (e.g. background job
 * completion) can toast on any page — including pages that mount no page-level toast outlet —
 * without double-rendering on pages that do.
 */
@Injectable({
    providedIn: 'root',
})
export class SideMenuToastMessagesService extends ToastMessagesServiceBase {}
